export const NODE_ENV = {
  PRODUCTION: 'production',
};

/**
 * Reads a Vite environment variable, treating a blank value as absent.
 *
 * An undefined variable and an empty one must behave the same way: GitHub
 * Actions resolves a missing secret to an empty string, so without this the
 * blank value flows into the app and breaks it far from its origin.
 *
 * `devDefault` only applies outside production builds, so tests and fresh
 * clones run without any environment setup while production still fails
 * loudly rather than starting up misconfigured.
 */
function env(name, devDefault) {
  const value = import.meta.env[name]?.trim();

  if (value) return value;
  return import.meta.env.PROD ? undefined : devDefault;
}

export const CONFIG = {
  env: env('VITE_APP_ENV', 'dev'),
  // Kept as an empty string rather than undefined: it's interpolated into
  // request URLs, where a blank value must yield a relative path and not
  // the literal "undefined"
  serverRoot: env('VITE_SERVER_ROOT') ?? '',
  filestackApiKey: env('VITE_FILESTACK_API_KEY', 'no-filestack-key-in-dev'),
  s3Bucket: env('VITE_S3_BUCKET'),
  pusherKey: env('VITE_PUSHER_KEY'),
  miroApiKey: env('VITE_MIRO_API_KEY'),
  getStreamApiKey: env('VITE_GET_STREAM_API_KEY'),

  sentryDomain: 'a-world-for-us',
  sentryRelease: env('VITE_SENTRY_RELEASE'),
  sentryEnv: env('VITE_SENTRY_ENV'),
  sentryDsn: env('VITE_SENTRY_DSN'),

  extranetDevServerRoot: env('VITE_EXTRANET_DEV_SERVER_ROOT'),

  dokkuInstanceName: env('VITE_DIGIFORMA_DOKKU_INSTANCE'),
};
